module.exports = __webpack_public_path__ + "images/31df7caca129b9bfe937dc358d4887d7.svg";